import { render, staticRenderFns } from "./BlockMap.vue?vue&type=template&id=4a1fbd6b&scoped=true&"
import script from "./BlockMap.vue?vue&type=script&lang=ts&"
export * from "./BlockMap.vue?vue&type=script&lang=ts&"
import style0 from "./BlockMap.vue?vue&type=style&index=0&id=4a1fbd6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fbd6b",
  null
  
)

export default component.exports